module.exports = __webpack_public_path__ + "static/media/pn.b92c8225.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pn.svg
// module id = 226
// module chunks = 0